import React, { useEffect, useState } from "react";
import "../style/global.css";
import Button from "../common/Button/Button.js";
import Header from "../common/Header.js";
import "react-toastify/dist/ReactToastify.css";
import  ToastMsg from "../common/ToastMsg.js";
import { fetchUserDetails , sendOtp} from "../api/action";
import Popup from "../common/Popup.js";
import { Loader } from '../common/Loader';
import callimg from "../assets/Images/call.png"
import { notifyVisitorEvent } from "../api/action.js";
import mixpanel from "mixpanel-browser";


const CheckEligibility = () => {
  const [formData, setFormData] = useState({
    mobileNumber: "",
    name: "",
    email: "",
    panCard: "",
    dob: "",
  });

  const [error, setError] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [mobileNumberToPopup, setMobileNumberToPopup] = useState("");
  const [fetchedUserData, setFetchedUserData] = useState(null);
  const [fetchedUserDataProps,setFetchedUserDataProps] = useState(null);
  const [isEmailReadOnly, setIsEmailReadOnly] = useState(true);
  const [isPanCardReadOnly, setIsPanCardReadOnly] = useState(true);
  const [isDobReadOnly, setIsDobReadOnly] = useState(true);
  


  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const UserId = queryParams.get("user_id");
    localStorage.setItem("UserId",UserId)
    
    mixpanel.identify(UserId);
    mixpanel.track("Viewed_Check_Eligibility_Form", {
      "Platform": "m-site",
    });
   
    const UserID = localStorage.getItem("UserId")
    const payload = {
      event_name: "Viewed_Check_Eligibility_Form",
      event_body: {
        "Platform":"m-site",
        },
    };

    

    notifyVisitorEvent(payload)
      .then((response) => {
        console.log("NotifyVisitor popup_view Event Sent:", response);
      })
      .catch((error) => {
        console.error("Error sending NotifyVisitor popup_view event:", error);
      });
  }, []);
  
  const handleChange = (event) => {
    if (event.target.checked) {
      setIsChecked(true);
    } else {
      setIsChecked(false);
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("token");
    if (token) {
      localStorage.setItem("authToken", token);
      console.log("Token saved to localStorage:", token);
    } else {
      console.log("No token found in query parameters");
    }

    handleGetUserDetails();
  }, []);

  const isFormValid = () => {
    return (
      /^[7-9]\d{9}$/.test(formData.mobileNumber) && 
      /^[a-zA-Z\s]{3,}$/.test(formData.name) &&
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email) &&
      /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(formData.panCard) && 
      formData.dob
    );
  };

 
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "dob") {
      const isCompleteDate = /^\d{4}-\d{2}-\d{2}$/.test(value);
  
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else if (name === "email") {
      setIsEmailReadOnly(value === "");
    } else if (name === "panCard") {
      const upperCaseValue = value.toUpperCase();
      if (/^[A-Z]{0,5}[0-9]{0,4}[A-Z]{0,1}$/.test(upperCaseValue)) {
        setFormData((prev) => ({
          ...prev,
          [name]: upperCaseValue,
        }));
      }
      setIsPanCardReadOnly(value === "");
    } else if (name === "mobileNumber") {
      if (/^[0-9]*$/.test(value)) {
        if (value.length <= 10 && (value.length === 0 || /^[6-9]/.test(value))) {
          setFormData((prev) => ({
            ...prev,
            [name]: value,
          }));
        }
      }
    } else if (name === "name") {
      if (
        value === "" ||
        (value.length <= 250 && !/\s{2,}/.test(value))
      ) {
        setFormData((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  
  

  const handleSendOtp = (userData) => {
   
    console.log(userData, "userdata");
    
  
    setFetchedUserDataProps(userData)
    
    
    setLoader(true);
    sendOtp(userData)
      .then((response) => {
        setLoader(false);
        setIsPopupVisible(false);
        if (response?.otp_already_verified) {
          window.location.href = "/loan-success?otpVerified=true";
        }
        
        setTimeout(() => {
          setIsPopupVisible(true);
        }, 1000); 
        ToastMsg("OTP sent successfully", "success");  
      })
      .catch((err) => {
        setLoader(false);
  
        if (err?.response?.data?.send_otp_api_error?.error?.detail === "User has not invested in mutual funds") 
          {
          window.location.href = "/loan-reject";
        } else if(err?.response?.data?.send_otp_api_error?.error?.detail === "Invalid PAN/PEKRN, Mobile/Email combination"){
          setError(err?.message);
          ToastMsg("Error: " + err?.message, "error");  
          window.location.href = "/loan-reject?pan-mobile-status=notMatch";
        }
      });
  };
  
  
  
  const handleGetUserDetails = () => {
    
    setLoader(true);
    fetchUserDetails()
      .then((data) => {
        setLoader(false);
        
if (data?.response?.consent_given === true) {
  setIsChecked(true);
}

        const userData = {
          mobileNumber: data.response.phone_number,
          name: data.response.name,
          email: data.response.email || "",
          panCard: data.response.pan || "",
          dob: data.response.dob || "",
                };
        const userDataprops = {
          mobileNumber: data.response.phone_number || "",
          name: data.response.name || "",
          email: data.response.email || "",
          panCard: data.response.pan || "",
          dob: data.response.dob || "",
        };
        
        setFetchedUserDataProps(userDataprops); 
        setFetchedUserData(userData); 
        setFormData(userData);
        localStorage.setItem("userDetails", JSON.stringify(userData));
        localStorage.setItem("userDetailsLoaded", "true");
        window.dispatchEvent(new Event("storageChanged"));
  
        setIsEmailReadOnly(!!data.response.email);
        setIsPanCardReadOnly(!!data.response.pan);
        setIsDobReadOnly(!!data.response.dob);
      })
      .catch((err) => {
        setLoader(false);
        setError(err?.message);
        ToastMsg(err?.message, "error");
      });
  };
  
  
  

  const handleContinueClick = () => {
    mixpanel.track("Interacted_Check_Eligibility_Form", {
      "Platform": "m-site",
      "Clicked on": "Continue",
    });

    const UserID = localStorage.getItem("UserId")
 
    
    const payload = {
      event_name: "Interacted_Check_Eligibility_Form",
      event_body: {
        "Clicked on": "Continue",
        "platform" : "m-site",
        },
    };
  
    notifyVisitorEvent(payload)
      .then((response) => {
        console.log("NotifyVisitor button_click Event Sent:", response);
      })
      .catch((error) => {
        console.error("Error sending NotifyVisitor button_click event:", error);
      });


    if (isFormValid() && fetchedUserData) {
      const userData = {};
  
      if (formData.mobileNumber !== fetchedUserData.mobileNumber) {
        userData.phone_number = formData.mobileNumber;
      }
      if (formData.email !== fetchedUserData.email) {
        userData.email = formData.email;
      }
      if (formData.panCard !== fetchedUserData.panCard) {
        userData.pan = formData.panCard;
      }
      if (formData.dob !== fetchedUserData.dob) {
        userData.dob = formData.dob;
      }
      if (formData.name !== fetchedUserData.name) {
        userData.name = formData.name;
      }
      if (isChecked) {
        userData.consent_given = true;
      }
  
      handleSendOtp(userData); 
  
      setMobileNumberToPopup(formData.mobileNumber);
      
    }
  };
  console.log(fetchedUserDataProps, "jkhhjgjhghj");
  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };

  return (
    <div className="check-eligibility mb-160">
      {loader ? <Loader /> : null}
      <Header />
      <form className="eligibility-form">
        <span>Mobile Number (as per PAN Card)</span>
        <div className="input-container firstdiv">
  <label
    className={`floating-label ${formData.mobileNumber ? "filled" : ""}`}
  >
    Mobile Number
  </label>
  <div className="input-wrapper">
    <img src={callimg} width={21} alt="phoneimg" className="input-icon" />
    <input
      type="text"
      name="mobileNumber"
      value={formData.mobileNumber}
      onChange={handleInputChange}
    />
  </div>
</div>


        <span>Name</span>
        <div className="input-container">
          <label className={`floating-label ${formData.name ? "filled" : ""}`}>
            Enter Name
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
          />
        </div>

        <span>Email ID</span>
        <div className="input-container">
  <label className={`floating-label ${formData.email ? "filled" : ""}`}>
    Enter your Email ID
  </label>
  <input
    type="email"
    name="email"
    value={formData.email}
    onChange={handleInputChange}
    readOnly={isEmailReadOnly} 
    style={{ opacity: isEmailReadOnly ? 0.3 : 1 }} 
  />
</div>

        <span>PAN Card Number</span>
        <div className="input-container">
  <label className={`floating-label ${formData.panCard ? "filled" : ""}`}>
    Enter your PAN 
  </label>
  <input
    type="text"
    name="panCard"
    value={formData.panCard}
    onChange={handleInputChange}
    readOnly={isPanCardReadOnly} 
    style={{ opacity: isPanCardReadOnly ? 0.3 : 1 }}
  />
</div>

<span>Your Date of Birth</span>
{/* <div  className="input-container">
  <label className={`floating-label ${formData.dob ? "filled" : "opacityzero"}`}>
    Enter DOB
  </label>
  <input
    type="date"
    name="dob"
    value={formData.dob}
    onChange={handleInputChange}
    readOnly={isDobReadOnly} 
    style={{ opacity: isDobReadOnly ? 0.3 : 1 }}
    onKeyDown={(e) => e.preventDefault()} 
  />
</div> */}



<div 
  className="input-container" 
  onClick={() => document.querySelector('input[name="dob"]').showPicker()}
>
  <label className={`floating-label ${formData.dob ? "filled" : "opacityzero"}`}>
    Enter DOB
  </label>
  <input
    type="date"
    name="dob"
    value={formData.dob}
    onChange={handleInputChange}
    readOnly={isDobReadOnly} 
    style={{ opacity: isDobReadOnly ? 0.3 : 1 }}
    onKeyDown={(e) => e.preventDefault()} 
  />
</div>

<label htmlFor="terms" class="main-checkk">
      I authorize PayMe to access my Mutual Fund portfolio.
              <input
                className="Termscheckbox"
                type="checkbox"
                checked={isChecked}

                onChange={handleChange}
                id="terms"
                name="terms"
              />
              <span class="geekmarkk"></span>
            </label>
      </form>

      

      {isFormValid() && isChecked ? (
        <div className="sticky-button-container ">
          <Button sslSecure="true" btnshadow="true" btnName="Continue" onClick={handleContinueClick} />
        </div>
      ) : (
        <div className="sticky-button-container ">
          <Button sslSecure="true" btnshadow="true" style={{ opacity: 0.5 }} btnName="Continue" />
        </div>
      )}

      {isPopupVisible && (
        <div className="popup-container">
          {/* <Popup mobileNumber={mobileNumberToPopup}  closePopup={handleClosePopup} /> */}
          <Popup
      mobileNumber={mobileNumberToPopup}
      closePopup={handleClosePopup}
      userData={fetchedUserDataProps}
    />
        </div>
      )}
    </div>
  );
};

export default CheckEligibility;
